import { helpers, email } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import ErrorList from './ErrorList'

export default {
  props: ['formData', 'formOptions', 'formLabels'],
  components: {
    ErrorList
  },
  setup: () => ({ v$: useVuelidate() }),
  validations () {
    return {
      formData: {
        email: {
          email: helpers.withMessage('Bitte geben Sie eine valide E-Mail Adresse an.', email)
        },
        mobileNumber: {
          phoneRegex: helpers.withMessage('Bitte geben Sie eine valide Handynummer in dem folgenden Format ein: +49 123 45678910', val => !val || (val && (/^\+[0-9\s]+$/).test(val)))
        }
      }
    }
  },
  methods: {
    onChangeMobileNumber (e) {
      const value = e.target.value
      if (value) {
        this.formData.mobileNumber = value.replaceAll(/([^0-9+\s{1}])/g, '')
      }
    },
    setErrorId(fieldName) {
      const errors = this.v$.formData[fieldName].$errors
      return errors.length ? `errors--${fieldName}` : null
    },
  },
  template: `
    <div class="application__fields__input-group" style="--inputgroup-width:100%">
        <label for="email" class="form__label">{{formLabels['email']}}</label>
        <input :aria-describedby="setErrorId('email')" type="email" name="email"
            v-model="formData.email"
            id="email"
            class="form__input" placeholder="" autocomplete="email">
        <error-list :errors="v$.formData.email.$errors" :id="setErrorId('email')"/>
    </div>

    <div class="application__fields__input-group" style="--inputgroup-width:100%">
        <label for="mobileNumber" class="form__label">{{formLabels['mobileNumber']}}</label>
        <input :aria-describedby="setErrorId('mobileNumber')" type="tel" v-model="formData.mobileNumber" name="mobileNumber" id="mobileNumber" class="form__input" placeholder="" @input="onChangeMobileNumber">
        <error-list :errors="v$.formData.mobileNumber.$errors" :id="setErrorId('mobileNumber')"/>
    </div>
    `
}
